import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import {fetchTranslations, initTranslations, getSupportedBrowserLanguage} from '@bnr-dev/translate';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import PrimeVue from 'primevue/config';

import localTranslations from './locales/translations.json';

import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';

import '@bnr-dev/theme/fonts/bnr-taxifix/style.scss';

import './styles/main.scss';
import localStorageTrack from './utils/functions/localStorageTrack';

localStorageTrack(process?.env?.VUE_APP_SIGN_IN_URL, true);

const app = createApp(App);

Sentry.init({
    app,
    dsn: 'https://d27a3071b7e44c3b80b2c9705aa3a2ba@o108361.ingest.sentry.io/6132443',
    integrations: [
        new Integrations.BrowserTracing({
            routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            tracingOrigins: [
                'https://ott-a.bnr.dk',
                'https://ott-c.bnr.dk',
                'https://www.taxifix.no',
                /^\//
            ]
        })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,
    logErrors: true, // vue renderer should still log to console,
    environment: process.env.NODE_ENV,
    ignoreErrors: [
        "ERROR_CODE_EXPIRED_JWT", // Should handle auth errors better, when there's time to implement it
        "Object captured as exception with keys: errorTitle, json", // Should handle fetch errors better, when there's time to implement it
        "isMathOcrAvailable", // Browser extension
        "predictionDistributor.getValue", // Browser extension
        "dictateStateDistributor.getValue", // Browser extension
        "getDictionariesByLanguageId", // Browser extension
        "availableTextCheckLanguagesDistributor.getValue", // Browser extension
        "availableLanguagesDistributor.getValue", // Browser extension
        "dictionariesDistributor.getValue", // Browser extension
        "lettersVoicesDistributor.getValue", // Browser extension
        "appSettingsDistributor.getValue", // Browser extension
        "wordsDistributor.getValue", // Browser extension
        "lettersVoicesDistributor.getValue", // Browser extension
        "appSettingsDistributor.getValue", // Browser extension
        "DefineExpirationForLanguagePacks.getValue", // Browser extension
        "userDistributor.getValue", // Browser extension
        "speechVoicesDistributor.getValue", // Browser extension
        "isDictateAvailable", // Browser extension
        "isPredictionAvailable", // Browser extension
    ],
});

let i18n;
const locale = getSupportedBrowserLanguage();
fetchTranslations(process.env.VUE_APP_SIMPLE_LOCALIZE_PROJECT_TOKEN)
    .then(simpleLocalizeJson => {
        i18n = initTranslations([simpleLocalizeJson], locale);
    })
    .catch(error => {
        console.log('Error fetching translations - using local file.', error, localTranslations);
        i18n = initTranslations([localTranslations], locale);
    })
    .finally(() => {
        app.use(i18n);
        app.use(router);
        app.use(PrimeVue);
        app.mount('#app');
    });

